/* =========================================================================
   BRANDJUNG CUSTOM CODE
   Datei:   assets/custom-eliot-header.js
   Zweck:   Verhalten für die Custom-Eliot-Header-Section
            (Mega-Menü-Hover, Mobile-Drawer, Sticky-Scroll).
   Status:  Eigenständige Komponente — kein Standard-Theme-Code, keine
            Abhängigkeit zu header.js oder anderen Theme-Skripten.
            Der „custom-" Prefix kennzeichnet die Datei als BRANDJUNG-
            Custom-Asset und grenzt sie eindeutig vom Symmetry-Theme ab.
   Wartung: BRANDJUNG Agentur — Anpassungen bitte über separate Branch.

   - Vanilla JS, kein Build-Step nötig.
   - Greift ausschließlich auf .elt-* Selektoren der eigenen Section zu.
   - Kein globaler Namespace, keine Theme-Globals — nur ein anonymer IIFE.
   - Section-Refresh-safe via shopify:section:load; idempotent durch
     dataset.eltInited-Flag.
   ========================================================================= */

(function () {
  function init(root) {
    if (!root || root.dataset.eltInited === '1') return;
    root.dataset.eltInited = '1';

    // Diese Initializer sind voneinander unabhängig — laufen immer.
    initHelp(root);
    initDrawer(root);
    initStickyScroll(root);

    // Desktop-Mega-Menü-Hover ist optional: ohne Haupt-Linklist
    // (oder ohne Top-Items) bricht init() hier ab — Drawer & Sticky
    // sind bereits oben verdrahtet.
    var nav    = root.querySelector('.elt-nav__row');
    var mega   = root.querySelector('.elt-mega');
    var items  = root.querySelectorAll('.elt-nav__item');
    var panels = root.querySelectorAll('.elt-mega__panel');
    if (!nav || !mega || !items.length) return;

    var hideTimer = null;

    function show(id) {
      clearTimeout(hideTimer);
      var hasPanel = false;
      items.forEach(function (it) {
        it.classList.toggle('is-active', it.dataset.menuId === id);
      });
      panels.forEach(function (p) {
        var match = p.dataset.menuId === id;
        p.classList.toggle('is-active', match);
        if (match) hasPanel = true;
      });
      mega.classList.toggle('is-open', hasPanel);
    }

    function hide() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        items.forEach(function (it) { it.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        mega.classList.remove('is-open');
      }, 120);
    }

    items.forEach(function (it) {
      var id = it.dataset.menuId;
      var hasSub = it.dataset.hasSubmenu === 'true';
      if (!hasSub) return;

      it.addEventListener('mouseenter', function () { show(id); });
      it.addEventListener('focus',      function () { show(id); });
    });

    nav.addEventListener('mouseleave', hide);
    mega.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    mega.addEventListener('mouseleave', hide);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
  }

  function initDrawer(root) {
    // Burger sitzt im Header, Drawer ist seit dem Stacking-Context-Fix
    // Sibling der <header> — daher nicht über root, sondern über
    // aria-controls verknüpft.
    var burger = root.querySelector('.elt-nav__burger');
    if (!burger) return;
    var drawerId = burger.getAttribute('aria-controls');
    var drawer   = drawerId ? document.getElementById(drawerId) : null;
    if (!drawer) return;

    var backdrop  = drawer.querySelector('.elt-drawer__backdrop');
    var panes     = drawer.querySelectorAll('.elt-drawer__pane');
    var rootPane  = drawer.querySelector('.elt-drawer__pane--root');
    var openBtns  = drawer.querySelectorAll('[data-open-pane]');
    var backBtns  = drawer.querySelectorAll('.elt-drawer__back');
    var closeBtns = drawer.querySelectorAll('.elt-drawer__close');

    function showPane(id) {
      panes.forEach(function (p) {
        var isActive = (p.dataset.pane === id);
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    function resetToRoot() {
      panes.forEach(function (p) {
        if (p === rootPane) return;
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
    }

    function open()  {
      drawer.classList.add('is-open');
      document.documentElement.classList.add('elt-no-scroll');
      drawer.setAttribute('aria-hidden', 'false');
    }
    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('elt-no-scroll');
      drawer.setAttribute('aria-hidden', 'true');
      // Nach der Slide-Out-Animation auf den Root-Pane zurückspringen,
      // damit der nächste Open-Vorgang oben startet.
      setTimeout(resetToRoot, 280);
    }

    burger.addEventListener('click', open);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    if (backdrop) backdrop.addEventListener('click', close);
    backBtns.forEach(function (btn) { btn.addEventListener('click', resetToRoot); });
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { showPane(btn.dataset.openPane); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function initStickyScroll(root) {
    if (!root.classList.contains('is-sticky')) return;
    var update = function () {
      root.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initHelp(root) {
    var help = root.querySelector('[data-elt-help]');
    if (!help) return;
    var toggle = help.querySelector('.elt-nav__help-toggle');
    var panel  = help.querySelector('.elt-nav__help-panel');
    if (!toggle || !panel) return;

    function close() {
      help.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = help.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!help.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function initAll() {
    document.querySelectorAll('.elt-header').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-Editor section reload
  document.addEventListener('shopify:section:load', initAll);
})();
